export default __webpack_public_path__ + "images/614512eabd067d2057f77f862ce2d7ba-atlanta_desktop.webp";